// import { gsap } from 'gsap';
import toggle from '../helpers/class-toggle';

export default () => {
	const sgs = document.querySelectorAll('.tabs__sg');
	const ACTIVE_BTN = 'tabs__table-button--active';
	const ACTIVE_TAB = 'tabs__table-tab--active';

	sgs.forEach(function(sg) {
		const buttons = sg.querySelectorAll('.tabs__table-button');
		const tabs = sg.querySelectorAll('.tabs__table-tab');

		if (buttons.length && tabs.length) {
			buttons.forEach(function(btn, index) {
				btn.addEventListener('click', (e) => {
					toggle(buttons, btn, ACTIVE_BTN);
					toggle(tabs, tabs[index], ACTIVE_TAB);
				});
			});
		}
	});
};